module.exports = __webpack_public_path__ + "static/media/Zamzama c. 1940s.70ba4c17.jpg";